import React from 'react';
import classnames from 'classnames';
import ArrowDown from '../../Icons/ArrowDown';
import NativeDropdown from '../NativeDropdown';
import noop from 'lodash/noop';
import s from './MobileNativeDropdown.scss';
/**
 * A dropdown that uses the native select and meant for mobile UIs
 */ export const MobileNativeDropdown = ({ items, title, className, titleClassName, arrowClassName, isLegacyFormInput, onSelect = noop })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['native-dropdown-wrap'], s['updated-inputs'], isLegacyFormInput && s['legacy-form-input'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['native-dropdown-title-wrap'],
        "aria-hidden": "true"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['native-dropdown-title'], titleClassName)
    }, title), /*#__PURE__*/ React.createElement(ArrowDown, {
        className: classnames(s['native-dropdown-arrow'], arrowClassName)
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['native-dropdown-hidden']
    }, /*#__PURE__*/ React.createElement(NativeDropdown, {
        onSelect: onSelect,
        items: items
    })));
};
MobileNativeDropdown.displayName = 'MobileNativeDropdown';
export default MobileNativeDropdown;

//# sourceMappingURL=MobileNativeDropdown.js.map